<template>
    <div class="col-lg-6 col-md-6 col-sm-12" id="business_settings_step">
        <div class="collapse-margin collapse-icon" id="company-setting-collapser">
            <div class="card mx-auto">
                <div class="card-header " id="paymentOne" data-toggle="collapse" role="button" data-target="#company-setting-collapse" aria-expanded="true" aria-controls="company-setting-collapse">
                    <div class="justify-content-between lead collapse-title">
                        <div class="media">
                            <div class="media-body mx-auto">
                                <div class="row mx-auto">
                                    <p><span class="badge badge-primary badge-glow mr-2">Step 2: </span></p>
                                    <h3 class="text-primary mx-auto">Business Settings </h3>
                                </div>
                                <div class="design-group">
                                    <h6 class="section-label">Business Settings:</h6>
                                    <div v-if="BusinessStore.business.setting_status">
                                        <div class="badge badge-glow badge-sm mr-0" :class="BusinessStore.business.setting_status?.class">
                                            {{ BusinessStore.business.setting_status?.title }} <i :data-feather="BusinessStore.business.setting_status?.icon"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="company-setting-collapse" class="open" aria-labelledby="paymentOne" data-parent="#company-setting-collapser">
                    <hr>
                    <div class="card-body">
                        <div>
                            <p class="card-text font-medium-2">
                                Next Step is to setup your <strong>Business Operational Settings</strong>. <br /> <br>
                                This is the area where you setup your Emails, Mailing, Fax, SMS & other Settings in order to operate your business.<br>
                            </p>
                            <hr>
                        </div>
                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">

                            <a href="#" type="submit" class="btn btn-primary mr-sm-1 mb-1 mb-sm-0"
                                data-toggle="modal" data-target="#company_setting_modal_update">
                                Business Settings
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../stores/UserStore.js'
import { useBusinessStore } from '../../../stores/BusinessStore.js'
export default{
    setup() {
        return {
            userStore: useUserStore(),
            BusinessStore: useBusinessStore()
        }
    },
    watch: {
    },
    mounted() {
        
    },
}
</script>